import React from "react"
import { AppCardTitle } from "@components"


export default function RealTimeTableTitle({ timeStamp }) {
	return <AppCardTitle icon="magnifying-glass" title="Real Time Searches:" subtitle={timeStamp}/>
}
